import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import IState from '../../../core/models/IState';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { validateRequired , validateEndDateGreaterOrEqualRequired, validateMaxLength} from '../../../helpers/validation.helper';
import { FormattedMessage } from 'react-intl';
import { getSensorSelector } from '../../../core/selectors/sensor.selector';
import DateTimeWidget from "../../../shared/components/DateTimeWidget/DateWidget";
import ReduxFormInput from '../../../shared/components/ReduxFormHandlers/ReduxFormInput';

interface IProps {
    id: number;
    isLoading:boolean;
    submitHandler: (data: any) => void;
    onModalClosed: () => void;
    buidlingList: Array<string>;
}

const IAQDownloadSensorForm: React.FC<InjectedFormProps<any, IProps> & IProps> = (props: any) => {
    const [dateType, setDateType] = useState<string>("MeasurementTime");
    const submitHandler = (values:any) => {
        values.DateType =dateType;
        props.submitHandler(values);
    }
    return (
        <Modal className="add-user-modal device-pop-up" show={true} centered onHide={props.onModalClosed} autoComplete="off">
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage id='Prepare_CSV' />
                </Modal.Title>
            </Modal.Header>

            <form onSubmit={props.handleSubmit((values: any) => submitHandler(values))} noValidate>
                <Modal.Body>
                    <div className="row">
                        <div className={"col-md-12 mb-1 mt-1"}>
                            <label className="label-style"><FormattedMessage id='File_Prefix' /> : </label>
                            <Field
                            className="form-control"
                            name="Prefix"
                            component={ReduxFormInput}
                            type="text"
                            min={3}
                            max={20}
                            validate={[
                                validateMaxLength(20, 'Validation_File_Prefix_Max_Char')
                            ]}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className={"col-md-6"}>
                            <FormattedMessage id='Date_type' /> : 
                        </div>
                    </div>    
                    <div className="row" >
                        <div className={"col-md-6"}>
                            <input className="form-check-input " type="radio" name="DateType" id="DateType2"  
                                onChange={() => setDateType('MeasurementTime')} 
                                defaultChecked/>
                            <label className="form-check-label" htmlFor="DateType2">
                                <FormattedMessage id='Measurement_time' />
                            </label>
                        </div>
                        <div className={"col-md-6"}>
                            <input className="form-check-input" type="radio" name="DateType" id="DateType1" 
                                value='ReceiveTime' onChange={() => setDateType('ReceiveTime') }/>
                            <label className="form-check-label" htmlFor="DateType1" >
                                <FormattedMessage id='Receive_time' />
                            </label>
                        </div>
                    </div>
                    <div className="row" >
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="label-style"><FormattedMessage id='Start_Date' /></label>
                                <Field
                                    className="form-control"
                                    name="StartDate"
                                    component={DateTimeWidget}
                                    autoComplete="off"
                                    validate={[validateRequired("Validation_Required_StartDate")]}
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="label-style"><FormattedMessage id='End_Date' /></label>
                                <Field
                                    className="form-control"
                                    name="EndDate"
                                    component={DateTimeWidget}
                                    autoComplete="off"
                                    validate={[validateRequired("Validation_Required_EndDate"),
                                    validateEndDateGreaterOrEqualRequired("EndDate_Greater_Required")]
                                }
                                />
                            </div>
                        </div>
                    </div>
{/* 
                    <div className="form-group">
                        <label className="label-style"><FormattedMessage id='Sensor_Label_Building' /></label>

                        <Field
                            className="form-control"
                            name="Building"
                            component={ComboBoxWidget}
                            searchData={props.buidlingList}
                            validate={[
                                validateRequired("Sensor_Validation_Required_Building")]} />
                    </div> */}
                </Modal.Body>

                <div className="modal-footer">
                    <div className="form-group row tab-action">
                        <div className="col-12 px-0">
                            <Button variant="primary" onClick={props.onModalClosed}><FormattedMessage id='Button_Cancel' /></Button>
                            <LoaderButton type="submit" isLoading={props.isLoading} text="Button_Start" />
                        </div>
                    </div>
                </div>
            </form>

        </Modal>
    )
}


const mapStateToProps = (state: IState) => ({
    initialValues: getSensorSelector(state),
});


const form = reduxForm<any, IProps>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
    form: 'IAQDownloadSensorForm',
    enableReinitialize: true,
    onSubmitFail: (errors: any) => {
        // toast.error(formatMessage('Validation_Correct_error'));
    }
})(IAQDownloadSensorForm);


export default connect(mapStateToProps)(form);
